interface DeductionForSummary {
  status: string;
  amount: number;
}

export function summariseDeductions(deductions: DeductionForSummary[]) {
  return deductions.reduce(
    (summary, deduction) => {
      if (deduction.status === 'Booked' || deduction.status === 'Approved') {
        summary.count += 1;
        summary.totalAmount += deduction.amount;
      }
      return summary;
    },
    { count: 0, totalAmount: 0 }
  );
}
